<template>
  <OChatBox
    class="flex flex-1 w-full h-full"
    :comments="comments"
    :send-comment="sendComment"
    :get-comments="getComments"
    :is-loading="isLoading"
    tipo="task"
  />
</template>

<script setup>
import { api, URLS } from 'js/modules/axios'
import { ref } from 'vue'
import OChatBox from './OChatBox.vue'

const { rowId } = defineProps({
  rowId: Number,
})

const comments = ref([
  {
    id: 1,
    usuario: {
      id: 1,
      nome: 'Darlene Robertson',
      foto: 'https://cdn.quasar.dev/img/avatar4.jpg',
    },
    data_amigavel: '1 meses atrás',
    comentario:
      'Acabei de fazer o upload de um arquivo e a qualidade permaneceu intacta. Ótimo para documentos importantes!',
    usuario_criacao: 1,
  },
])

const sendComment = async (comentario) => {
  const { data } = await api.post(`${URLS.comentariosSolicitacoes}`, {
    solicitacao_arquivo: rowId,
    usuario_criacao: 1,
    comentario:comentario.txt
  })
  return data
}

const getComments = async () => {
  const { data } = await api.get(
    `${URLS.comentariosSolicitacoes}?solicitacao_arquivo=${rowId}`
  )
  comments.value = data
  return data
}
const isLoading = ref(false)
</script>

<style lang="scss" scoped></style>
